const gutterFAQ = [
  {
    question: "What types of gutters do you install?",
    answer:
      "We install seamless aluminum, copper, and galvanized steel gutters<IN_CITY_ZIP> in a range of sizes and profiles. Available styles include K-style, half-round, and box gutters to match your home’s architectural design.",
  },
  {
    question: "How often should I replace my gutters?",
    answer:
      "Most gutter systems last 20–30 years<IN_CITY_ZIP> with proper maintenance. Signs it’s time for replacement include rust, sagging, leaks, or pulling away from the fascia board.",
  },
  {
    question: "Do gutters require permits?",
    answer:
      "Gutter replacement alone usually doesn’t require a permit<IN_CITY_ZIP>. But if it’s part of a larger roofing or exterior remodel, we ensure full code compliance and obtain any necessary permits on your behalf.",
  },
  {
    question: "How long does gutter installation take?",
    answer:
      "Most gutter installations<IN_CITY_ZIP> are completed in a single day. Larger or multi-story homes may require 2–3 days based on accessibility and customization.",
  },
  {
    question: "Are seamless gutters better than sectional gutters?",
    answer:
      "Yes. Seamless gutters are custom-cut onsite to fit your roof perfectly<IN_CITY_ZIP>. They minimize leaks, improve performance, and deliver a cleaner appearance with lower maintenance needs.",
  },
  {
    question: "Do you install gutter guards or leaf protection systems?",
    answer:
      "Yes. We offer several guard systems<IN_CITY_ZIP> including micro-mesh and solid cover options to keep leaves and debris out of your gutters — reducing maintenance and preventing clogs.",
  },
  {
    question: "What’s the cost of new gutter installation?",
    answer:
      "Gutter installation costs typically range from $1,200 to $3,500<IN_CITY_ZIP> depending on material, home size, and style. We provide detailed, no-obligation estimates before any work begins.",
  },
  {
    question: "How do I know if my gutters need cleaning or repair?",
    answer:
      "Overflowing water during rain, pooling near your foundation, or disconnected gutter sections<IN_CITY_ZIP> are clear signs. Regular inspections help catch these issues early and protect your home.",
  },
  {
    question: "Do you offer warranties on gutters?",
    answer:
      "Yes. We include manufacturer warranties on gutter materials and a workmanship guarantee<IN_CITY_ZIP> from Modern Build for peace of mind and long-term protection.",
  },
  {
    question: "Can you match gutter colors to my home’s exterior?",
    answer:
      "Yes. We offer a wide selection of gutter colors and finishes<IN_CITY_ZIP> to match or complement your home’s trim, siding, or roof. Custom color-matching is available upon request.",
  },
  {
    question: "Are downspouts included in your gutter installations?",
    answer:
      "Yes. Every gutter installation<IN_CITY_ZIP> includes properly sized downspouts designed to direct water away from your foundation. We also offer custom drainage solutions when needed.",
  },
];

export default gutterFAQ;
